
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

import { uploadImage } from '@/utils/utility-manager'
import tagModule from '@/store/tag'
import whitelabelModule from '@/store/whitelabel'
import { TextFieldRules } from '@/utils/enums'
import { Tag } from '@/types/Tag'

@Component({
  name: 'TagEditor'
})
class TagEditor extends Vue {
  @Prop() readonly edit?: boolean
  private rules = TextFieldRules
  private currentImage = ''

  private form: Partial<Tag> = {
    image: ''
  }

  private get tag(): Tag | undefined {
    return tagModule.tag
  }

  private get whitelabel() {
    return whitelabelModule.whitelabel
  }

  private get whitelabels() {
    return whitelabelModule.whitelabels
  }

  @Watch('tag')
  private async setTag(): Promise<void> {
    if (!this.edit) return
    this.form = JSON.parse(JSON.stringify(this.tag))

    if (this.form.image) {
      this.currentImage = this.form.image!
    }
  }

  private get tagHasImage() {
    return this.form.image && this.form.image.length > 0
  }

  private async addImage(file: File): Promise<void> {
    if (!file || !this.isImage(file) || file.size > 4194304) {
      this.resetImage()
      return
    }
    const result = await uploadImage(file)

    this.form.image = result[0].key
    this.currentImage = result[0].url
  }

  private resetImage(): void {
    this.form.image = undefined
  }

  private isImage(file: File): boolean {
    if (!file) return false
    return file.type.split('/')[0] === 'image'
  }

  private created(): void {
    this.setTag()
  }

  private async saveTag(): Promise<void> {
    Object.assign(this.form, { whitelabel: this.whitelabel._id })
    console.log(this.edit)

    if (!this.edit) {
      tagModule.create(this.form)
    } else {
      tagModule.update(this.form)
    }
    document.dispatchEvent(new Event('close-tag'))
  }
}

export default TagEditor
